// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".main." + {"31":"ff5f8f32743f85dc55ff","506":"3ec760f46bf4b9f7a5de","683":"af29e35b0213e91a12f6"}[chunkId] + ".js";
};